import { render, staticRenderFns } from "./SolutionAssets.vue?vue&type=template&id=13a9a76e&"
import script from "./SolutionAssets.vue?vue&type=script&lang=js&"
export * from "./SolutionAssets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports